<script>
  import { scale } from 'svelte/transition';
  import { backOut } from 'svelte/easing';

  export let count = 0;

  // Fancy "bubble" scale transition intro
  const TRANSITION_IN = { duration: 250, easing: backOut };
</script>

<span class="Count" aria-hidden="true" in:scale={TRANSITION_IN}>{count}</span>

<style>@charset "UTF-8";
.Count {
  box-sizing: border-box;
  z-index: 1;
  display: inline-flex;
  place-content: center center;
  align-items: center;
  height: 20px;
  min-width: 20px;
  padding: 0 4px;
  margin-top: -10px;
  margin-left: -8px;
  color: white;
  background-color: #006aff;
  border-radius: 999em;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 12px;
  line-height: 1;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  text-align: center;
}</style>
